import { useScreenState } from 'components/Screen';
import { useInfiniteQuery } from 'query';
import {
  FILTERS,
  LIMIT,
  OFFSET,
  TABLE_SETTINGS,
} from 'scenes/FinancePage/constants';
import { loadFinance } from 'scenes/FinancePage/sources/loadFinance';

import { grid } from './queryKeyFactory';

export const useFinance = () => {
  const screenState = useScreenState();
  return useInfiniteQuery(
    grid({
      [TABLE_SETTINGS]: screenState[TABLE_SETTINGS],
      [FILTERS]: screenState[FILTERS],
    }),
    async ({ pageParam }: any) => {
      const { offset, limit, ...other } = screenState[TABLE_SETTINGS];
      const page = pageParam ?? 0;
      return loadFinance({
        [FILTERS]: screenState[FILTERS],
        [TABLE_SETTINGS]: {
          ...other,
          [LIMIT]: limit,
          [OFFSET]: page * limit + offset,
        },
      });
    },
    {
      getNextPageParam: (lastPage: any, allPages: any) => {
        const count = lastPage?.count || 0;
        if (count === 0) {
          return 0;
        }

        const loadedPagesCount = allPages.reduce(
          (r: number, c: { rows: [] }) => r + c.rows.length,
          0
        );
        if (loadedPagesCount < count) {
          return allPages.length;
        }
      },
    }
  );
};
